import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import axiosClient from "./api/axiosClient";
import "./Home.css";
import "./HomeAuthButton.css";
import logo from './logo.png'; 

/* ------------------------------------------------------------------ */
/*  CONTACT CONSTANTS — edit these two lines if the number changes    */
/* ------------------------------------------------------------------ */
const PHONE_DISPLAY = "9626 1515 11";
const PHONE_TEL = "919626151511";       // for tel: link (with country code)
const WHATSAPP_NUMBER = "919626151511"; // for wa.me link (with country code)
const MAP_LINK = "https://maps.app.goo.gl/x62cHaeWA1v7TH8Y8";
const GALLERY_ENDPOINT = "/api/v1/gallery/";
const SEO_ENDPOINT = "/api/v1/seo/";

/* ------------------------------------------------------------------ */
/*  REFERENCE PHOTOS — free-to-use (Unsplash License: free for        */
/*  commercial use, no attribution required) equipment/interior shots */
/*  used as real, working placeholders. Swap any of these for your    */
/*  own showroom photos whenever you have them — same prop, one line. */
/* ------------------------------------------------------------------ */
const IMG = {
  treadmill: "https://images.unsplash.com/photo-1542766788-a2f588f447ee?auto=format&fit=crop&w=1200&q=80",
  gymInterior: "https://images.unsplash.com/photo-1540496905036-5937c10647cc?auto=format&fit=crop&w=1600&q=80",
  dumbbells: "https://images.unsplash.com/photo-1603734220970-25a0b335ca01?auto=format&fit=crop&w=1200&q=80",
  homeGym: "https://images.unsplash.com/photo-1758957646695-ec8bce3df462?auto=format&fit=crop&w=1200&q=80",
  strengthPlates: "https://images.unsplash.com/photo-1620188467120-5042ed1eb5da?auto=format&fit=crop&w=1200&q=80",
  exerciseBike: "https://images.unsplash.com/photo-1724763750901-3d69d27ec1c0?auto=format&fit=crop&w=1200&q=80",
};

/* ------------------------------------------------------------------ */
/*  ICONS (inline SVG — no extra packages needed)                     */
/* ------------------------------------------------------------------ */
const IconPhone = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.9 21 3 13.1 3 3.4 3 2.8 3.4 2.4 4 2.4h3.4c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.6.1.4 0 .8-.3 1L6.6 10.8Z"
      stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" fill="none"
    />
  </svg>
);

const IconWhatsApp = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M17 14.3c-.3-.1-1.6-.8-1.9-.9-.2-.1-.4-.1-.6.1-.2.3-.7.9-.8 1-.2.2-.3.2-.5.1-.3-.1-1.2-.4-2.2-1.4-.8-.7-1.4-1.6-1.5-1.9-.2-.3 0-.4.1-.6l.4-.5c.1-.1.2-.3.2-.4.1-.2 0-.3 0-.5-.1-.1-.6-1.4-.8-2-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.2.3-.9.9-.9 2.1 0 1.2.9 2.4 1 2.6.1.2 1.8 2.8 4.4 3.8.6.3 1.1.4 1.5.5.6.2 1.2.2 1.6.1.5-.1 1.6-.6 1.8-1.3.2-.6.2-1.1.2-1.2-.1-.2-.3-.2-.6-.4Z"
      fill="currentColor"
    />
    <path
      d="M12 2C6.5 2 2 6.4 2 12c0 1.9.5 3.6 1.4 5.1L2 22l5.1-1.3c1.4.8 3.1 1.2 4.9 1.2 5.5 0 10-4.4 10-10S17.5 2 12 2Z"
      stroke="currentColor" strokeWidth="1.5" fill="none"
    />
  </svg>
);

const IconMenu = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const IconClose = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M5 5l14 14M19 5L5 19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const IconPin = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M12 22s7-6.6 7-12A7 7 0 0 0 5 10c0 5.4 7 12 7 12Z"
      stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"
    />
    <circle cx="12" cy="10" r="2.4" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

const IconArrowUp = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconCheck = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M4 12.5l5 5L20 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconTruck = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M2 6h11v10H2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M13 10h4l4 3v3h-8z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    <circle cx="6.5" cy="17.5" r="1.6" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="17" cy="17.5" r="1.6" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

const IconTool = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M14.7 6.3a4 4 0 0 1-5.4 5.4L4 17l3 3 5.3-5.3a4 4 0 0 1 5.4-5.4L21 6l-3-3-3.3 3.3Z"
      stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"
    />
  </svg>
);

const IconShield = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M12 3l7 3v5c0 4.6-3 8.4-7 10-4-1.6-7-5.4-7-10V6l7-3Z"
      stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"
    />
    <path d="M9 12l2 2 4-4.2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconWallet = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <rect x="3" y="6" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="1.5" />
    <path d="M3 10h18" stroke="currentColor" strokeWidth="1.5" />
    <circle cx="17" cy="14" r="1.3" fill="currentColor" />
  </svg>
);

/* Category line-icons, single stroke style so the whole set feels
   like one hand drew it. */
const IconTreadmill = (props) => (
  <svg viewBox="0 0 40 40" fill="none" {...props}>
    <rect x="6" y="19" width="24" height="6" rx="3" stroke="currentColor" strokeWidth="1.6" />
    <path d="M8 22h20" stroke="currentColor" strokeWidth="1.2" strokeDasharray="1.5 3" />
    <path d="M28 19V13a4 4 0 0 1 4-4h1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="33" cy="9" r="2" stroke="currentColor" strokeWidth="1.6" />
    <path d="M10 25v4M26 25v4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);
const IconElliptical = (props) => (
  <svg viewBox="0 0 40 40" fill="none" {...props}>
    <circle cx="20" cy="20" r="13" stroke="currentColor" strokeWidth="1.6" />
    <path d="M11 26l9-14 9 14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const IconCycle = (props) => (
  <svg viewBox="0 0 40 40" fill="none" {...props}>
    <circle cx="11" cy="27" r="6" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="29" cy="27" r="6" stroke="currentColor" strokeWidth="1.6" />
    <path d="M11 27l7-13h7l4 13M18 14l6 7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
const IconHomeGym = (props) => (
  <svg viewBox="0 0 40 40" fill="none" {...props}>
    <path d="M8 8v24M32 8v24M8 12h24M8 28h24" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="20" cy="20" r="3" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);
const IconStrength = (props) => (
  <svg viewBox="0 0 40 40" fill="none" {...props}>
    <rect x="4" y="16" width="5" height="8" rx="1" stroke="currentColor" strokeWidth="1.6" />
    <rect x="31" y="16" width="5" height="8" rx="1" stroke="currentColor" strokeWidth="1.6" />
    <path d="M9 20h22" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
  </svg>
);
const IconAccessory = (props) => (
  <svg viewBox="0 0 40 40" fill="none" {...props}>
    <circle cx="20" cy="24" r="9" stroke="currentColor" strokeWidth="1.6" />
    <path d="M15 15c0-3 2.2-5 5-5s5 2 5 5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

/* ------------------------------------------------------------------ */
/*  IMAGE SLOT                                                        */
/*  Renders a real photo once it's dropped into /public/images/.      */
/*  Until then (or if a file is missing), it shows a quiet shimmer /  */
/*  icon placeholder instead of a broken-image icon.                  */
/* ------------------------------------------------------------------ */
function ImageSlot({ src, alt, icon: Icon, className = "", imgClassName = "", style }) {
  const [failed, setFailed] = useState(false);
  const [loaded, setLoaded] = useState(false);

  if (failed) {
    return (
      <div className={`img-slot img-slot--fallback ${className}`} style={style}>
        {Icon ? <Icon className="icon" /> : null}
      </div>
    );
  }

  return (
    <div className={`img-slot ${className}`} style={style}>
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={`${imgClassName} ${loaded ? "img-slot__loaded" : ""}`}
        onLoad={() => setLoaded(true)}
        onError={() => setFailed(true)}
      />
    </div>
  );
}

/* ------------------------------------------------------------------ */
/*  DATA                                                              */
/* ------------------------------------------------------------------ */
const CATEGORIES = [
  {
    icon: IconTreadmill,
    name: "Treadmills",
    desc: "AC, DC, Motorized, Foldable, Semi-Commercial & Commercial models for every budget.",
    badge: "Best Seller",
    image: IMG.treadmill,
  },
  {
    icon: IconElliptical,
    name: "Elliptical Trainers",
    desc: "Low-impact, full-body cardio machines that go easy on the joints.",
    image: IMG.homeGym,
  },
  {
    icon: IconCycle,
    name: "Exercise Cycles",
    desc: "Compact, reliable cardio built for daily home use.",
    image: IMG.exerciseBike,
  },
  {
    icon: IconCycle,
    name: "Spin Bikes",
    desc: "Studio-grade resistance for serious indoor cycling sessions.",
    image: IMG.exerciseBike,
  },
  {
    icon: IconCycle,
    name: "Upright & Recumbent Bikes",
    desc: "Classic upright training or back-supported, joint-friendly rides.",
    image: IMG.exerciseBike,
  },
  {
    icon: IconHomeGym,
    name: "Home Gyms",
    desc: "Multi-station systems that pack a full workout into one frame.",
    badge: "Popular",
    image: IMG.homeGym,
  },
  {
    icon: IconStrength,
    name: "Strength Machines",
    desc: "Pin-loaded & plate-loaded machines for focused muscle training.",
    image: IMG.strengthPlates,
  },
  {
    icon: IconAccessory,
    name: "Fitness Accessories",
    desc: "Dumbbells, weight plates, kettlebells, yoga mats & more.",
    image: IMG.dumbbells,
  },
];

/* Showroom / installation photos — used as a fallback when the      */
/* backend gallery is empty, so the section never looks unfinished.  */
const GALLERY = [
  { src: IMG.gymInterior, alt: "Spacious fitness showroom floor with cardio equipment on display", size: "g-wide" },
  { src: IMG.homeGym, alt: "Home gym setup with treadmill and cardio equipment by a window", size: "" },
  { src: IMG.strengthPlates, alt: "Commercial strength section with barbell and weight plates", size: "g-tall" },
  { src: IMG.treadmill, alt: "Treadmill on display, ready for delivery", size: "" },
  { file: "delivery-team.jpg", alt: "VP Fitness delivery and installation team at work", size: "" },
  { src: IMG.dumbbells, alt: "Dumbbell rack close-up", size: "g-wide" },
];

const CITIES = [
  "Madurai",
  "Virudhunagar",
  "Aruppukottai",
  "Sattur",
  "Kovilpatti",
  "Rajapalayam",
  "Across India",
];

const STATS = [
  { end: 4000, suffix: "+", label: "Gym Setups Installed" },
  { end: 9, suffix: "", label: "Equipment Categories" },
  { end: 6, suffix: "+", label: "Cities Served" },
];

const TRUST_POINTS = [
  {
    icon: IconShield,
    title: "Genuine Equipment",
    desc: "AC, DC & Commercial-grade machines built to run all day, every day.",
  },
  {
    icon: IconTruck,
    title: "Doorstep Delivery",
    desc: "Delivered to your home or gym across South Tamil Nadu on schedule.",
  },
  {
    icon: IconTool,
    title: "On-site Installation",
    desc: "Our own team sets everything up — no guesswork, no loose bolts.",
  },
  {
    icon: IconWallet,
    title: "EMI Available",
    desc: "Flexible payment options so budget never blocks your goals.",
  },
];

const PROCESS = [
  { title: "Enquire", desc: "Call or WhatsApp us with what you're looking to build." },
  { title: "Consult", desc: "We understand your space, budget and training goals." },
  { title: "Select", desc: "Pick equipment at our showroom or from our catalogue." },
  { title: "Delivery", desc: "We deliver to your doorstep, right on schedule." },
  { title: "Install & Support", desc: "On-site setup, plus ongoing after-sales care." },
];

/* Placeholder testimonials — swap in real customer quotes before
   publishing; keep them short and specific once you do. */
const TESTIMONIALS = [
  {
    quote:
      "Set up our entire commercial floor in under a week. The team knew exactly which machines suited our space and budget.",
    name: "Karthik R.",
    role: "Gym Owner, Madurai",
  },
  {
    quote:
      "Bought a foldable treadmill for home — honest advice, no upselling, and installation was done the same evening.",
    name: "Priya S.",
    role: "Home Buyer, Virudhunagar",
  },
  {
    quote:
      "Been servicing our strength machines for two years now. They respond fast whenever something needs attention.",
    name: "Mohammed A.",
    role: "Fitness Studio, Rajapalayam",
  },
];

const FAQS = [
  {
    q: "Do you offer EMI or financing options?",
    a: "Yes, EMI options are available on select equipment. Ask our team for the schemes running right now.",
  },
  {
    q: "How soon can equipment be delivered?",
    a: "Most orders within Madurai are delivered in 2–4 days. Other cities may take a little longer depending on stock and distance.",
  },
  {
    q: "Is installation included with my purchase?",
    a: "Yes — our own team handles delivery and on-site installation for treadmills, home gyms and multi-station machines.",
  },
  {
    q: "Do you provide after-sales service?",
    a: "Yes, we offer maintenance and spare-part support after your purchase, not just a one-time sale.",
  },
  {
    q: "Which cities do you serve?",
    a: "Madurai, Virudhunagar, Aruppukottai, Sattur, Kovilpatti, Rajapalayam, and other locations across India on request.",
  },
  {
    q: "Can I try equipment before buying?",
    a: "Absolutely — walk into our Tallakulam showroom to test machines yourself before you decide.",
  },
];

/* ------------------------------------------------------------------ */
/*  SCROLL-REVEAL HOOK                                                 */
/* ------------------------------------------------------------------ */
function useReveal() {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShown(true);
          obs.unobserve(el);
        }
      },
      { threshold: 0.18 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return [ref, shown];
}

/* Animated counter, starts once its wrapper is visible */
function Counter({ end, suffix, active }) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!active) return;
    let start = null;
    const duration = 1400;
    const step = (ts) => {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setVal(Math.floor(eased * end));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [active, end]);
  return (
    <span className="stat-number">
      {val}
      {suffix}
    </span>
  );
}

/* Fixed vertical "load rail" — the page's signature element. Fills
   and racks brass plates as the visitor scrolls the page. */
function LoadRail() {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const scrollTop = h.scrollTop || document.body.scrollTop;
      const height = h.scrollHeight - h.clientHeight;
      const p = height > 0 ? Math.min(100, Math.max(0, (scrollTop / height) * 100)) : 0;
      setPct(p);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const plateStops = [15, 35, 55, 75, 92];

  return (
    <div className="load-rail" aria-hidden="true">
      <span className="load-rail__pct">{Math.round(pct)}%</span>
      <div className="load-rail__track">
        <div className="load-rail__fill" style={{ height: `${pct}%` }} />
        {plateStops.map((stop) => (
          <span
            key={stop}
            className={`load-rail__plate ${pct >= stop ? "load-rail__plate--in" : ""}`}
            style={{ bottom: `${stop}%` }}
          />
        ))}
      </div>
      <span className="load-rail__cap" />
    </div>
  );
}

function ScrollTop() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      className={`scroll-top ${visible ? "scroll-top--visible" : ""}`}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
    >
      <IconArrowUp className="icon" />
    </button>
  );
}

function TrustCard({ icon: Icon, title, desc }) {
  return (
    <div className="trust-card">
      <Icon className="icon" />
      <div>
        <h4>{title}</h4>
        <p>{desc}</p>
      </div>
    </div>
  );
}

function ProcessStep({ index, title, desc, active }) {
  return (
    <div className={`process-step ${active ? "process-step--in" : ""}`} style={{ transitionDelay: `${index * 100}ms` }}>
      <div className="process-step__num">{String(index + 1).padStart(2, "0")}</div>
      <h4>{title}</h4>
      <p>{desc}</p>
    </div>
  );
}

/* ------------------------------------------------------------------ */
/*  GALLERY — fetches real photos from the backend gallery API and    */
/*  falls back to the static placeholder set if none exist yet.       */
/*  Clicking a photo opens a full-screen lightbox view.                */
/* ------------------------------------------------------------------ */
function Gallery() {
  const [ref, shown] = useReveal();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activePhoto, setActivePhoto] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axiosClient.get(GALLERY_ENDPOINT);
        const list = Array.isArray(data?.data) ? data.data : [];
        const active = list.filter((p) => p.status !== 0 && p.photo);
        if (!cancelled) setItems(active);
      } catch (err) {
        if (!cancelled) setItems([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const displayItems =
    items.length > 0
      ? items.map((p) => ({
          src: p.photo,
          alt: p.description || p.tag || "VP Fitness showroom photo",
          tag: p.tag,
          description: p.description,
        }))
      : GALLERY.map((g) => ({ ...g, src: g.src || `/images/gallery/${g.file}` }));

  const [search, setSearch] = useState("");
  const q = search.trim().toLowerCase();
  const filteredItems = q
    ? displayItems.filter(
        (g) =>
          (g.tag || "").toLowerCase().includes(q) ||
          (g.description || "").toLowerCase().includes(q) ||
          (g.alt || "").toLowerCase().includes(q)
      )
    : displayItems;

  return (
    <section className="gallery" id="gallery" ref={ref}>
      <div className="section-head" style={{ marginBottom: 32 }}>
        <p className="eyebrow eyebrow--center">Proof, Not Promises</p>
        <h2 className="section-title">Inside our showroom &amp; real installs.</h2>
        <p className="section-kicker" style={{ margin: "0 auto" }}>
          A look at machines on our floor and gyms we've set up recently.
        </p>
      </div>

      <div className="gallery-search">
        <svg className="gallery-search__icon" viewBox="0 0 24 24" fill="none">
          <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.8" />
          <path d="M21 21l-4.3-4.3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
        <input
          type="text"
          placeholder="Search gallery (e.g. treadmill, showroom, home gym)…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="gallery-grid">
        {!loading && filteredItems.length === 0 && (
          <p className="gpage__state" style={{ gridColumn: "1 / -1" }}>
            No photos match your search.
          </p>
        )}
        {!loading &&
          filteredItems.map((g, i) => (
            <button
              type="button"
              key={g.src + i}
              className={`gallery-card ${shown ? "gallery-card--in" : ""}`}
              style={{ transitionDelay: `${i * 60}ms` }}
              onClick={() => setActivePhoto(g)}
              aria-label={`View full photo: ${g.alt}`}
            >
              <span className="gallery-card__photo">
                <ImageSlot
                  src={g.src}
                  alt={g.alt}
                  imgClassName="gallery-card__img"
                  className={shown ? "img-slot--in" : ""}
                />
                <span className="gallery-card__zoom">
                  <svg viewBox="0 0 24 24" fill="none">
                    <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.8" />
                    <path d="M21 21l-4.3-4.3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                    <path d="M11 8v6M8 11h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                  </svg>
                </span>
              </span>
              {(g.tag || g.description) && (
                <span className="gallery-card__caption">{g.tag || g.description}</span>
              )}
            </button>
          ))}
      </div>

      {activePhoto && (
        <GalleryLightbox photo={activePhoto} onClose={() => setActivePhoto(null)} />
      )}
    </section>
  );
}

/* Full-screen click-to-view overlay for a gallery photo. Closes on
   backdrop click, close button, or Escape key. */
function GalleryLightbox({ photo, onClose }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      className="gallery-lightbox"
      onMouseDown={(e) => e.target === e.currentTarget && onClose()}
      role="dialog"
      aria-modal="true"
    >
      <button className="gallery-lightbox__close" onClick={onClose} aria-label="Close">
        <IconClose className="icon" />
      </button>
      <div className="gallery-lightbox__inner">
        <img src={photo.src} alt={photo.alt} className="gallery-lightbox__img" />
        {(photo.tag || photo.description) && (
          <div className="gallery-lightbox__caption">
            {photo.tag && <strong>{photo.tag}</strong>}
            {photo.description && <p>{photo.description}</p>}
          </div>
        )}
      </div>
    </div>
  );
}

function Testimonials() {
  const [ref, shown] = useReveal();
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (!shown) return;
    const id = setInterval(() => {
      setActive((a) => (a + 1) % TESTIMONIALS.length);
    }, 5500);
    return () => clearInterval(id);
  }, [shown]);

  return (
    <section className="testimonials" id="reviews" ref={ref}>
      <p className="eyebrow eyebrow--center">What Our Customers Say</p>
      <h2 className="section-title">Real gyms, real homes, real feedback.</h2>

      <div className="testi-viewport">
        {TESTIMONIALS.map((t, i) => (
          <div className={`testi-card ${active === i ? "testi-card--active" : ""}`} key={t.name}>
            <p className="testi-quote">{t.quote}</p>
            <div className="testi-name">{t.name}</div>
            <div className="testi-role">{t.role}</div>
          </div>
        ))}
      </div>

      <div className="testi-dots">
        {TESTIMONIALS.map((t, i) => (
          <button
            key={t.name}
            className={`testi-dot ${active === i ? "testi-dot--active" : ""}`}
            onClick={() => setActive(i)}
            aria-label={`Show testimonial ${i + 1}`}
          />
        ))}
      </div>
      <p className="testi-note">Sample reviews shown — swap in your customers' actual words before publishing.</p>
    </section>
  );
}

function FaqItem({ item, isOpen, onToggle }) {
  const innerRef = useRef(null);
  const [maxH, setMaxH] = useState("0px");

  useEffect(() => {
    if (isOpen && innerRef.current) {
      setMaxH(`${innerRef.current.scrollHeight}px`);
    } else {
      setMaxH("0px");
    }
  }, [isOpen]);

  return (
    <div className={`faq-item ${isOpen ? "faq-item--open" : ""}`}>
      <button className="faq-item__q" onClick={onToggle} aria-expanded={isOpen}>
        {item.q}
        <span className="faq-item__plus" />
      </button>
      <div className="faq-item__a" style={{ maxHeight: maxH }}>
        <div className="faq-item__a-inner" ref={innerRef}>
          {item.a}
        </div>
      </div>
    </div>
  );
}

/* Top-corner auth control: shows "Login" for visitors, and "Dashboard"
   for anyone already signed in. Clicking Login opens the modal instead
   of navigating away, so people never leave the page to sign in. */
function AuthNavButton() {
  const { isAuthenticated, openLoginModal } = useAuth();
  const navigate = useNavigate();

  if (isAuthenticated) {
    return (
      <button className="navbar__auth-btn" onClick={() => navigate("/dashboard")}>
        <span>Dashboard</span>
      </button>
    );
  }

  return (
    <button className="navbar__auth-btn" onClick={openLoginModal}>
      <span>Login</span>
    </button>
  );
}

/* ------------------------------------------------------------------ */
/*  SEO — pulls the live meta title/description/OG tags from the      */
/*  dashboard's "SEO Content" page (backend) and writes them into      */
/*  the real <head> at runtime, on top of a LocalBusiness JSON-LD      */
/*  schema so Google can show rich results (address, phone, hours)    */
/*  in local search. Falls back to sensible defaults if the SEO API   */
/*  hasn't been saved yet (fresh install, empty fields, or offline).  */
/*  No extra packages needed. If this app is server-rendered           */
/*  (Next.js etc.) move this logic into that framework's <Head>       */
/*  instead for best SEO results (crawlers don't always run JS).      */
/* ------------------------------------------------------------------ */
function Seo() {
  useEffect(() => {
    const DEFAULT_TITLE = "VP Fitness Madurai | Gym & Home Fitness Equipment Showroom";
    const DEFAULT_DESCRIPTION =
      "VP Fitness in Tallakulam, Madurai supplies treadmills, home gyms, strength machines & fitness accessories with delivery, installation and after-sales service across South Tamil Nadu.";

    const setMeta = (name, content, attr = "name") => {
      let tag = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    const setCanonical = () => {
      let canonical = document.head.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", window.location.origin + "/");
    };

    const setSchema = () => {
      let schemaTag = document.getElementById("vp-fitness-schema");
      if (!schemaTag) {
        schemaTag = document.createElement("script");
        schemaTag.type = "application/ld+json";
        schemaTag.id = "vp-fitness-schema";
        document.head.appendChild(schemaTag);
      }
      schemaTag.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "SportingGoodsStore",
        name: "VP Fitness",
        image: IMG.gymInterior,
        telephone: `+${PHONE_TEL}`,
        priceRange: "$$",
        address: {
          "@type": "PostalAddress",
          streetAddress: "Basement Shop, Ragem Plaza, Building No. 156, Shop No. 11, Alagar Kovil Main Rd, Tallakulam",
          addressLocality: "Madurai",
          addressRegion: "Tamil Nadu",
          postalCode: "625002",
          addressCountry: "IN",
        },
        areaServed: CITIES,
        openingHoursSpecification: [
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            opens: "09:30",
            closes: "20:30",
          },
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: ["Sunday"],
            opens: "10:00",
            closes: "18:00",
          },
        ],
        url: window.location.origin + "/",
      });
    };

    // Applies one set of title/description/OG values to the real <head>.
    const applyToHead = ({ title, description, ogTitle, ogDescription, keywords }) => {
      document.title = title;
      setMeta("description", description);
      if (keywords) setMeta("keywords", keywords);
      setMeta("og:title", ogTitle || title, "property");
      setMeta("og:description", ogDescription || description, "property");
      setMeta("og:type", "business.business", "property");
      setMeta("og:locale", "en_IN", "property");
      setMeta("twitter:card", "summary_large_image");
      setCanonical();
      setSchema();
    };

    // 1) Paint sensible defaults immediately so the tab title / meta
    //    are never blank while the SEO API call is in flight.
    applyToHead({ title: DEFAULT_TITLE, description: DEFAULT_DESCRIPTION });

    // 2) Then overlay whatever's saved in the dashboard's SEO Content
    //    page, once it loads. Any field left blank in the dashboard
    //    keeps the default instead of writing an empty tag.
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axiosClient.get(SEO_ENDPOINT);
        const seo = data?.data;
        if (!cancelled && seo) {
          applyToHead({
            title: seo.meta_title || DEFAULT_TITLE,
            description: seo.meta_description || DEFAULT_DESCRIPTION,
            ogTitle: seo.og_title,
            ogDescription: seo.og_description,
            keywords: seo.keywords,
          });
        }
      } catch (err) {
        // SEO API not reachable/wired up yet — the defaults set above
        // already cover the page, so there's nothing else to do here.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return null;
}

/* ------------------------------------------------------------------ */
/*  MAIN COMPONENT                                                    */
/* ------------------------------------------------------------------ */
export default function Home() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [openFaq, setOpenFaq] = useState(0);

  const [statsRef, statsShown] = useReveal();
  const [catRef, catShown] = useReveal();
  const [processRef, processShown] = useReveal();
  const [cityRef, cityShown] = useReveal();
  const [aboutRef, aboutShown] = useReveal();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const waLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hi VP Fitness, I'm interested in gym equipment. Please share details."
  )}`;

  return (
    <div className="vp-root">
      <Seo />
      <LoadRail />
      <ScrollTop />

      {/* ---------------- NAVBAR ---------------- */}
      <header className={`navbar ${scrolled ? "navbar--solid" : ""}`}>
        <div className="navbar__inner">
       
            <div className="navbar__logo">
            <ImageSlot
                src={logo}
                alt="VP Fitness Logo"
            />
            </div>
          <nav className={`nav-links ${menuOpen ? "nav-links--open" : ""}`}>
            <a href="#categories" onClick={() => setMenuOpen(false)}>Equipment</a>
            <a href="#process" onClick={() => setMenuOpen(false)}>How It Works</a>
            <a href="#gallery" onClick={() => setMenuOpen(false)}>Gallery</a>
            <a href="#about" onClick={() => setMenuOpen(false)}>Why Us</a>
            <a href="#reviews" onClick={() => setMenuOpen(false)}>Reviews</a>
            <a href="#faq" onClick={() => setMenuOpen(false)}>FAQ</a>
            <a href="#contact" onClick={() => setMenuOpen(false)}>Visit Showroom</a>
            <a href={`tel:+${PHONE_TEL}`} className="nav-links__call">
              <IconPhone className="icon" /> {PHONE_DISPLAY}
            </a>
          </nav>

          <AuthNavButton />

          <button
            className="menu-btn"
            aria-label="Toggle menu"
            onClick={() => setMenuOpen((v) => !v)}
          >
            {menuOpen ? <IconClose className="icon" /> : <IconMenu className="icon" />}
          </button>
        </div>
      </header>

      <main>
      {/* ---------------- HERO ---------------- */}
      <section className="hero" id="top">
        <div className="hero__photo">
          <ImageSlot
            src={IMG.gymInterior}
            alt="Fitness equipment showroom interior"
          />
        </div>
        <div className="hero__glow" />
        <div className="hero__glow hero__glow--brass" />
        <div className="hero__inner">
          <span className="hero__badge">
            <span className="hero__badge-dot" />
            Madurai&rsquo;s Finest Fitness Equipment Showroom
          </span>

          <h1 className="hero__title">
            <span className="line"><span>Build the gym</span></span>
            <span className="line"><span>your goals</span></span>
            <span className="line"><span className="text-ember">deserve.</span></span>
          </h1>

          <p className="hero__sub">
            From foldable home treadmills to full commercial strength lines &mdash; VP Fitness has
            equipped 4000+ gyms across Madurai, Virudhunagar, Aruppukottai, Sattur, Kovilpatti,
            Rajapalayam and beyond.
          </p>

          <div className="hero__cta">
            <a href={waLink} target="_blank" rel="noopener noreferrer" className="btn btn--whatsapp">
              <IconWhatsApp className="icon" /> Chat on WhatsApp
            </a>
            <a href={`tel:+${PHONE_TEL}`} className="btn btn--outline">
              <IconPhone className="icon" /> Call {PHONE_DISPLAY}
            </a>
          </div>

          <div className="hero__trust">
            <span className="hero__trust-item"><IconCheck className="icon" /> Genuine Equipment</span>
            <span className="hero__trust-item"><IconCheck className="icon" /> On-site Installation</span>
            <span className="hero__trust-item"><IconCheck className="icon" /> After-Sales Support</span>
          </div>
        </div>
      </section>

      {/* ---------------- MARQUEE ---------------- */}
      <div className="marquee">
        <div className="marquee__track">
          {[...CATEGORIES, ...CATEGORIES].map((c, i) => (
            <span className="marquee__item" key={i}>
              {c.name}
              <i className="marquee__dot" />
            </span>
          ))}
        </div>
      </div>
      <div className="marquee marquee--reverse">
        <div className="marquee__track">
          {[...CITIES, ...CITIES].map((c, i) => (
            <span className="marquee__item" key={i}>
              {c}
              <i className="marquee__dot" />
            </span>
          ))}
        </div>
      </div>

      {/* ---------------- STATS ---------------- */}
      <section className="stats" ref={statsRef}>
        {STATS.map((s, i) => (
          <div className={`stat ${statsShown ? "stat--in" : ""}`} style={{ transitionDelay: `${i * 120}ms` }} key={s.label}>
            <Counter end={s.end} suffix={s.suffix} active={statsShown} />
            <span className="stat-label">{s.label}</span>
          </div>
        ))}
      </section>

      {/* ---------------- TRUST STRIP ---------------- */}
      <section className="trust-strip">
        {TRUST_POINTS.map((t) => (
          <TrustCard key={t.title} {...t} />
        ))}
      </section>

      {/* ---------------- CATEGORIES ---------------- */}
      <section className="categories" id="categories" ref={catRef}>
        <div className="section-head">
          <p className="eyebrow eyebrow--center">What We Stock</p>
          <h2 className="section-title">Every rack, rep &amp; run &mdash; covered.</h2>
          <p className="section-kicker" style={{ margin: "0 auto" }}>
            Nine categories, every budget. Browse what fits your space before you call.
          </p>
        </div>

        <div className="cat-grid">
          {CATEGORIES.map((c, i) => {
            const Icon = c.icon;
            return (
              <div
                className={`cat-card ${catShown ? "cat-card--in" : ""}`}
                style={{ transitionDelay: `${i * 80}ms` }}
                key={c.name}
              >
                {c.badge && <span className="cat-card__badge">{c.badge}</span>}
                <ImageSlot
                  src={c.image}
                  alt={`${c.name} available at VP Fitness Madurai`}
                  icon={c.icon}
                  className="cat-card__photo"
                />
                <div className="cat-card__body">
                  <div className="cat-card__icon">
                    <Icon className="icon icon--lg" />
                  </div>
                  <h3>{c.name}</h3>
                  <p>{c.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* ---------------- PROCESS ---------------- */}
      <section className="process" id="process" ref={processRef}>
        <div className="section-head">
          <p className="eyebrow eyebrow--center">How It Works</p>
          <h2 className="section-title">From enquiry to installed, in five steps.</h2>
        </div>
        <div className={`process-rail ${processShown ? "process-rail--in" : ""}`}>
          {PROCESS.map((p, i) => (
            <ProcessStep key={p.title} index={i} title={p.title} desc={p.desc} active={processShown} />
          ))}
        </div>
      </section>

      {/* ---------------- GALLERY ---------------- */}
      <Gallery />

      {/* ---------------- ABOUT / WHY US ---------------- */}
      <section className="about" id="about" ref={aboutRef}>
        <div className={`about__copy ${aboutShown ? "about__copy--in" : ""}`}>
          <p className="eyebrow">Why Gyms Trust VP Fitness</p>
          <h2 className="section-title">
            We don&rsquo;t just sell machines.
            <br />
            We set up gyms that run for years.
          </h2>
          <ul className="about__grid">
            <li><IconCheck className="icon" /> Genuine AC, DC &amp; Commercial-grade equipment built to run all day.</li>
            <li><IconCheck className="icon" /> End-to-end setup &mdash; from delivery to installation, at your space.</li>
            <li><IconCheck className="icon" /> Trusted by 4000+ home &amp; commercial gyms across South Tamil Nadu.</li>
            <li><IconCheck className="icon" /> Honest guidance on what actually fits your space and budget.</li>
          </ul>
          <a href={`tel:+${PHONE_TEL}`} className="btn btn--ember">
            <IconPhone className="icon" /> Talk to Our Team
          </a>
        </div>

        <div className={`about__visual ${aboutShown ? "about__visual--in" : ""}`}>
          <div className="plate-stack" aria-hidden="true">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </section>

      {/* ---------------- TESTIMONIALS ---------------- */}
      <Testimonials />

      {/* ---------------- CITIES ---------------- */}
      <section className="cities" id="cities" ref={cityRef}>
        <p className="eyebrow eyebrow--center">Where We&rsquo;ve Set Up Gyms</p>
        <h2 className="section-title">Serving South Tamil Nadu &amp; beyond.</h2>
        <div className="city-chips">
          {CITIES.map((c, i) => (
            <span
              className={`city-chip ${cityShown ? "city-chip--in" : ""}`}
              style={{ transitionDelay: `${i * 70}ms` }}
              key={c}
            >
              {c}
            </span>
          ))}
        </div>
      </section>

      {/* ---------------- FAQ ---------------- */}
      <section className="faq" id="faq">
        <div className="section-head" style={{ marginBottom: 32 }}>
          <p className="eyebrow eyebrow--center">Questions, Answered</p>
          <h2 className="section-title">Before you call, a few quick answers.</h2>
        </div>
        <div className="faq-list">
          {FAQS.map((item, i) => (
            <FaqItem
              key={item.q}
              item={item}
              isOpen={openFaq === i}
              onToggle={() => setOpenFaq(openFaq === i ? -1 : i)}
            />
          ))}
        </div>
      </section>

      {/* ---------------- CONTACT ---------------- */}
      <section className="contact" id="contact">
        <div className="contact__card">
          <p className="eyebrow">Visit the Showroom</p>
          <h2 className="section-title">Come lift, ride &amp; test before you buy.</h2>

          <div className="contact__row">
            <IconPin className="icon icon--accent" />
            <p>
              VP Fitness &mdash; Basement Shop, Ragem Plaza, Building No. 156, Shop No. 11,
              Alagar Kovil Main Rd, Tallakulam, Madurai, Tamil Nadu 625002
            </p>
          </div>
          <div className="contact__row">
            <IconPhone className="icon icon--accent" />
            <a href={`tel:+${PHONE_TEL}`}>{PHONE_DISPLAY}</a>
          </div>
          <div className="contact__row contact__hours">
            <span>&#128337;</span>
            <p style={{ margin: 0 }}>
              <strong>Mon&ndash;Sat</strong> 9:30 AM &ndash; 8:30 PM &nbsp;&bull;&nbsp; <strong>Sun</strong> 10:00 AM &ndash; 6:00 PM
            </p>
          </div>

          <div className="contact__actions">
            <a href={MAP_LINK} target="_blank" rel="noopener noreferrer" className="btn btn--outline">
              <IconPin className="icon" /> Get Directions
            </a>
            <a href={waLink} target="_blank" rel="noopener noreferrer" className="btn btn--whatsapp">
              <IconWhatsApp className="icon" /> Message Us
            </a>
          </div>
        </div>

        <div className="contact__map">
          <iframe
            title="VP Fitness Location"
            src="https://maps.google.com/maps?q=VP%20Fitness%20Ragem%20Plaza%20Alagar%20Kovil%20Main%20Rd%20Tallakulam%20Madurai&t=&z=15&ie=UTF8&iwloc=&output=embed"
            loading="lazy"
            allowFullScreen
          />
        </div>
      </section>

      </main>

      {/* ---------------- FOOTER ---------------- */}
      <footer className="footer">
        <div className="footer__top">
          {/* <span className="brand brand--footer">
            <span className="brand__mark">VP</span>
            <span className="brand__word">FITNESS<em>Madurai</em></span>
          </span> */}
           <div className="navbar__logo">
            <img
                src={logo}
                alt="VP Fitness Logo"
            />


            </div>

          <div className="footer__links">
            <div className="footer__col">
              <h5>Explore</h5>
              <a href="#categories">Equipment</a>
              <a href="#process">How It Works</a>
              <a href="#about">Why Us</a>
            </div>
            <div className="footer__col">
              <h5>Support</h5>
              <a href="#reviews">Reviews</a>
              <a href="#faq">FAQ</a>
              <a href="#contact">Visit Showroom</a>
            </div>
            <div className="footer__col">
              <h5>Reach Us</h5>
              <a href={`tel:+${PHONE_TEL}`}>{PHONE_DISPLAY}</a>
              <a href={waLink} target="_blank" rel="noopener noreferrer">WhatsApp Us</a>
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <p>&copy; {new Date().getFullYear()} VP Fitness. All rights reserved.</p>
          <p>Tallakulam, Madurai &mdash; Tamil Nadu 625002</p>
        </div>
      </footer>

      {/* ---------------- FLOATING ACTION BUTTONS ---------------- */}
      <div className="fab-stack">
        <a
          href={`tel:+${PHONE_TEL}`}
          className="fab fab--call"
          aria-label="Call VP Fitness"
        >
          <span className="fab__ring" />
          <IconPhone className="icon" />
        </a>
        <a
          href={waLink}
          target="_blank"
          rel="noopener noreferrer"
          className="fab fab--whatsapp"
          aria-label="Chat with VP Fitness on WhatsApp"
        >
          <span className="fab__ring" />
          <IconWhatsApp className="icon" />
        </a>
      </div>
    </div>
  );
}
